"use client";

// Thin client wrapper so we can use dynamic({ ssr: false }) for IosPwaHint.
// next/dynamic with ssr:false is only allowed in Client Components.
// The Suspense boundary is required because IosPwaHint uses useSearchParams().
import dynamic from "next/dynamic";
import { Suspense } from "react";

const IosPwaHint = dynamic(() => import("./ios-pwa-hint"), { ssr: false });

export default function IosPwaHintClient() {
  return (
    <Suspense fallback={null}>
      <IosPwaHint />
    </Suspense>
  );
}
